

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { map } from 'rxjs/operators';
import {AccountService} from "../../services";
import {environment} from "../../../../environments/environment";
import {MultiSportReport} from "../models/multiSportReport";
import {MultiSportReportItems} from "../models/multiSportReportItems";



@Injectable({ providedIn: 'root' })
export class MultiSportReportService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private accountService: AccountService
    ) {

    }

    get(createdAt, createdAtTo) {
        return this.http.post(`${environment.apiEndpoint}/v1/reports/multi-sport`, {
            'createdAt': createdAt,
            'createdAtTo': createdAtTo
        }, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map((x: MultiSportReportItems) => {
                return x;
            }));
    }
}
